import {PersonalLabel} from "../domain/entities/personal-label.entity";
import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

export class DeletePersonalLabelCommand extends AbstractCommand<PersonalLabel> {

    name = CommandName.DELETE_PERSONAL_LABEL;

    tags = ['entity', 'delete', 'personal-label'];

}
